import { render, staticRenderFns } from "./UploaderModal.vue?vue&type=template&id=36795c75"
import script from "./UploaderModal.vue?vue&type=script&lang=js"
export * from "./UploaderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports